export function Shorts() {
    return (
        <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.7221 8.94769L9.18877 0.172485H2.01734L0.486328 8.9348C1.77853 9.37029 3.17372 9.53262 4.64315 9.49567C4.7058 9.49399 4.76006 9.45201 4.7774 9.39156L5.62378 6.39078L6.47015 9.39156C6.48693 9.45202 6.54175 9.49399 6.6044 9.49567C8.05937 9.53262 9.44053 9.37366 10.7221 8.94769Z" fill="currentColor" stroke="black" strokeWidth="0.2" />
        </svg>
    )
}